import { useMutation } from "@apollo/client";
import { UPDATE_APPOINTMENT_MUTATION } from "@/graphql/appointments";
import { useAsyncAction } from "@/lib/hooks/use-async-action";
import { useSalonStore } from "@/lib/store/salon";

export const useCalendarAppointmentMutations = () => {
  const { currentSalon } = useSalonStore();
  const [updateAppointmentMutation] = useMutation(UPDATE_APPOINTMENT_MUTATION);

  const { execute: updateAppointment } = useAsyncAction(
    async (appointmentId: string, input: any) => {
      if (!currentSalon?.id) {
        throw new Error("No salon selected");
      }

      const result = await updateAppointmentMutation({
        variables: {
          salonId: currentSalon.id,
          appointmentId,
          input,
        },
      });

      return result;
    },
    {
      loadingMessage: "Updating appointment...",
      successMessage: "Appointment updated successfully!",
      errorMessage: "Failed to update appointment",
      showLoadingToast: true,
      showSuccessToast: true,
      showErrorToast: true,
    }
  );

  return {
    updateAppointment,
  };
};
